import {
  primaryColor,
  dangerColor,
  successColor,
  whiteColor,
  grayColor,
} from 'assets/jss/material-dashboard-pro-react';

const customInputStyle = {
  disabled: {
    opacity: '0.4',
    cursor: 'not-allowed',
    '&:before': {
      borderBottomStyle: 'solid !important',
    },
    '& input': {
      cursor: 'not-allowed',
    },
  },
  underline: {
    '&:hover:not($disabled):before,&:before': {
      borderColor: `${grayColor[4]}!important`,
      borderWidth: '1px !important',
    },
    '&:after': {
      borderColor: primaryColor[0],
    },
  },
  underlineError: {
    '&:hover:not($disabled):before,&:before': {
      borderColor: `${dangerColor[0]}!important`,
      borderWidth: '1px !important',
    },
    '&:after': {
      borderColor: dangerColor[0],
    },
  },
  underlineSuccess: {
    '&:after': {
      borderColor: successColor[0],
    },
  },
  labelRoot: {
    color: grayColor[20],
    cursor: 'pointer',
    display: 'inline-flex',
    fontSize: '14px',
    lineHeight: '1.4',
    fontWeight: '400',
    marginRight: '0',
  },
  labelRootError: {
    color: `${dangerColor[0]} !important`,
  },
  labelRootSuccess: {
    color: `${successColor[0]} !important`,
  },
  formControl: {
    margin: '0 0 5px 0',
    // paddingTop: "27px",
    position: 'relative',
    verticalAlign: 'unset',
    '& svg,& .fab,& .far,& .fal,& .fas,& .material-icons': {
      color: grayColor[14],
    },
  },
  whiteUnderline: {
    '&:hover:not($disabled):before,&:before': {
      backgroundColor: whiteColor,
    },
    '&:after': {
      backgroundColor: whiteColor,
    },
  },
  inputRoot: {
    marginTop: '0px !important',
  },
  input: {
    color: grayColor[14],
    '&,&::placeholder': {
      fontSize: '12px',
      fontFamily: '"Roboto", "Helvetica", "Arial", sans-serif',
      fontWeight: '400',
      lineHeight: '1.42857',
      opacity: '1',
    },
    '&::placeholder': {
      color: grayColor[3],
    },
  },
  whiteInput: {
    '&,&::placeholder': {
      color: whiteColor,
      opacity: '1',
    },
  },
  noSpinButtons: {
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
  },
  noArrowsNumberInput: {
    '&[type=number]': {
      '-moz-appearance': 'textfield',
    },
    '&::-webkit-outer-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    '&::-webkit-inner-spin-button': {
      '-webkit-appearance': 'none',
      margin: 0,
    },
    textAlign: 'center',
  },
};

export default customInputStyle;
